const infoBarType = {
    error: 'error',
    success: 'success'
};

export default infoBarType;